"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Palette, Lightbulb, Sparkles, Briefcase, Target, Users } from "lucide-react";
const services = [{
  id: 1,
  icon: Palette,
  title: "Master Craftsmanship",
  description: "Our team consists of experienced professionals who prioritise precision in every detail."
}, {
  id: 2,
  icon: Sparkles,
  title: "Attention to Detail",
  description: "From perfectly aligned tiles to seamless finishes, we focus on the elements that define quality."
}, {
  id: 3,
  icon: Briefcase,
  title: "Tailored Solutions",
  description: "Every project is custom-designed to reflect the client's lifestyle, vision, and budget.\n"
}, {
  id: 4,
  icon: Target,
  title: "On-Time Delivery",
  description: "We respect timelines and provide clear schedules — without unnecessary delays."
}, {
  id: 5,
  icon: Users,
  title: "Premium Materials",
  description: "We work exclusively with high-quality materials from trusted international suppliers.\n"
}, {
  id: 6,
  icon: Sparkles,
  title: "White-Glove Standard",
  description: "Clean, organised, and respectful work environments throughout the project lifecycle.\n"
}];
export default function OurExpertiseServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section id="our-expertise-services" className="bg-background ![padding:96px_24px_96px_24px]" ref={ref}>
      <div className={`mx-auto max-w-7xl transition-all duration-700 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        <div className="mb-12 text-center md:mb-16">
          <p className="mb-2 text-[14px] font-medium uppercase tracking-[0.1em] text-[#8b6e4c]">WHY CHOOSE KS LUXURY RENOVATIONS</p>
          <h2 className="font-display font-bold text-foreground !text-[44px]">Our Commitment to Excellence</h2>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={service.id} data-index={i} className="group border border-border bg-background transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-0.5 hover:shadow-[0_4px_8px_rgb(0_0_0_/_0.12)]">
                <CardHeader className="items-start gap-4">
                  <div className="flex size-12 items-center justify-center rounded-full border-[1.5px] border-muted transition-colors duration-[var(--duration-medium)] group-hover:border-accent">
                    <Icon className="size-6 text-muted transition-colors duration-[var(--duration-medium)] group-hover:text-accent-dark" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-xl font-semibold text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base leading-relaxed text-muted-foreground">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}